import React from 'react'; 
import './buttons-styles.css'

export default function Button({children, color, to}){
    
    return (
        <a className={`buttons ${color}`} href={to}>{children}</a>
    );
}